// src/com/tsr/TransPlanTsr.js
import React, { useState, useEffect, useRef } from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { TopContainer, Top, TopHeader, TopContent, ControlLine, NoDataBox } from '../../common/TopStyle';
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { arriveInfoListToSelectStoreRepo, bulkCompanyProductsListRepo, transPlanTsrItemRepo, transPlanTsrListRepo, userInfoRepo, vehInfoListOfDcRepo } from '../../value/AppModel';
import { useAlertSetter } from '../../api/app-hook';
import { useSnackbar } from 'notistack';
import { LIST_TRANS_PLAN_TSR } from './TransPlanTsrGql';
import { AppObject, AppStyle, AppWord, TopCode } from '../../value/AppConst';
import { LIST_ARRIVE_INFO_TO_SELECT_STORE } from '../arrive_info/ArriveInfoGql';
import { LIST_BULK_COMPANY_PRODUCTS } from '../bulk_company_products/BulkCompanyProductsGql';
import ValueMisc from '../../value/ValueMisc';
import VzmDateField from '../../common/VzmDateField';
import IsValid from '../../value/IsValid';
import AutoTextField from '../../common/AutoTextField';
import TransPlanTsrGroup from '../tsr/TransPlanTsrGroup';
import { TransitionGroup } from 'react-transition-group';
import { AppBar, Button, CircularProgress, Collapse, IconButton, Tab, Tabs } from '@mui/material';
import { devideVehiclesByCompany, LIST_VEH_INFO_OF_DC } from '../veh_info/VehInfoGql';
import { vehSorter } from '../trans_plan_launch/TransPlanLaunch';
import TransPlanTsrItem from './TransPlanTsrItem';



/**
 * 운송요청 조회
 * @returns 
 */
export default function TransPlanTsr() {
    // const menuTree = useReactiveVar(menuTreeRepo);
    const sessionInfo = useReactiveVar(userInfoRepo);
    const storeList = useReactiveVar(arriveInfoListToSelectStoreRepo);
    const [listParam, setListParam] = useState({storeId: null, planDate: ValueMisc.getYMD()});
    // const transPlanTsrListParam = useReactiveVar(transPlanTsrListParamRepo);
    // const transPlanTsrListData = useReactiveVar(transPlanTsrListRepo);
    const bulkCompanyProductsListData = useReactiveVar(bulkCompanyProductsListRepo);
    const vehInfoListOfDcData = useReactiveVar(vehInfoListOfDcRepo);
    const [tsrBoxList, setTsrBoxList] = useState([]); // like launchBoxList
    const [baseData, setBaseData] = useState({}); // {dcCd, storeId, arriveId, basicDockno, planDate, arriveInfo}
    const [showControls, setShowControls] = useState(true);
    const [selected, setSelected] = useState({hocha:0, item:null});
    const [openTsrDetail, setOpenTsrDetail] = useState(false); // 상차 상세내역 및 물류집기.
    const addAlert = useAlertSetter();
    const { enqueueSnackbar } = useSnackbar();
    const lastReloadRef = useRef(0);

    // ##### Call GraphQL to get List #####
    const [getTransPlanTsrList, responseList] = useLazyQuery(LIST_TRANS_PLAN_TSR, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetList(data, option)},
		onError: (error) => addAlert({title: 'TSR 조회 오류', message: [error.message]})
    });
    // Get store list from arrive_info table.
    const [getArriveInfoList, responseStoreList] = useLazyQuery(LIST_ARRIVE_INFO_TO_SELECT_STORE, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetStoreList(data, option)},
        onError: (error) => addAlert({title: '도착지 목록 조회 오류', message: [error.message]})
    });
    // 982 Bulk 상품 목록 조회
    const [getBulkCompanyProductsList, responseBulkCompanyProductsList] = useLazyQuery(LIST_BULK_COMPANY_PRODUCTS, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetBulkCompanyProductsList(data, option)},
		onError: (error) => addAlert({title: '벌크상품 목록 조회 오류', message: [error.message]})
    });
        const [getVehInfoListOfDc, responseVehInfoList] = useLazyQuery(LIST_VEH_INFO_OF_DC, {
            ...AppObject.NoCachedFetch,
            onCompleted: (data, option) => {onCompleteGetVehInfoList(data, option)},
            onError: (error) => addAlert({title: "차량목록 조회 오류", message: [error.message]})
        });

    const getTransPlanTsrListNow = (storeId, planDate) => {
        const dcCd = sessionInfo.user.getDcCd();
        if(!planDate) {
            planDate = ValueMisc.getYMD();
        }
        const param = {variables:{dcCd:dcCd, storeId:storeId, planDate:planDate}};
        getTransPlanTsrList(param);
    };

    // 날짜, 점포 변경 시 TSR 조회 호출
    // 다른 화면에서 transPlanTsrListParam 설정하고 이 화면으로 들어오면 바로 조회 가능함.
    /* useEffect(() => {
        if(transPlanTsrListParam.storeId && transPlanTsrListParam.planDate) {
            getTransPlanTsrListNow(transPlanTsrListParam.storeId, transPlanTsrListParam.planDate);
        }
        else if(!transPlanTsrListParam.planDate) {
            const newParam = {...transPlanTsrListParam, planDate:ValueMisc.getYMD()};
            transPlanTsrListParamRepo(newParam);
        }
    }, [transPlanTsrListParam]); */

    // 먼저 Store 목록을 가져온 후 transPlanTsrListParam의 내용에 따라서 최초 LIST_TRANS_PLAN_TSR 호출
    useEffect(() => {
        const dcCd = sessionInfo.user.getDcCd();
        let diff = new Date().getTime()/1000 - storeList.when;
        if(diff > 300) {
            getArriveInfoList({variables:{dcCd:dcCd}});
        }

        diff = new Date().getTime()/1000 - vehInfoListOfDcData.when;
        if(diff > 300) {
            getVehInfoListOfDc({variables:{dcCd:dcCd}});
        }
    }, []);

    const getBulkCompanyProductsListNow = () => {
        const diff = new Date().getTime()/1000 - bulkCompanyProductsListData.when;
        if(diff > 3600) {
            getBulkCompanyProductsList({variables:{bulkCompanyId:null, bulkProductsId:null}});
        }
    };

    // 982 Bulk 상품 목록 조회
    useEffect(()=>{
        if(sessionInfo.user.getDcCd() === TopCode.DcCode.Adc982) {
            getBulkCompanyProductsListNow();
        }
    }, [sessionInfo]);

    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetList = (data, clientOption) => {
        lastReloadRef.current = new Date().getTime()/1000;
        if(data.transPlanTsrList) {
            transPlanTsrListRepo({when:new Date().getTime()/1000, records:data.transPlanTsrList});
            // get max hocha (1 to maxHocha)
            let lastDockno = baseData.basicDockno;

            const launcherCount = data.transPlanTsrList.length;
            const launchers = data.transPlanTsrList.map(item => {
                return {
                    hocha: item.hocha,
                    item: item,
                };
            });
            setTsrBoxList(launchers);
            
            if(data.transPlanTsrList.length > 0) {
                const found = selected.item ?
                    data.transPlanTsrList.find(item=> item.planId === selected.item.planId) : null;
                if(found) {
                    setSelected({hocha:found.hocha, item:found});
                }
                else {
                    setSelected({hocha:data.transPlanTsrList[0].hocha, item:data.transPlanTsrList[0]});
                }
            }
            else setSelected({hocha:0, item:null});

            // set base data
            const store = storeList.records.find(item => item.storeId === listParam.storeId);
            if(store) {
                const newBaseData = {
                    dcCd: store.dcCd,
                    storeId: store.storeId,
                    arriveId: store.arriveId,
                    basicDockno: store.basicDockno,
                    planDate: listParam.planDate,
                    arriveInfo: store,
                };
                setBaseData(newBaseData);
                // setShowControls(data.transPlanTsrList.length > 0 ? false : true);
                setShowControls(false);
            }
            else {
                setBaseData({}); // reset base data
            }
        }
    };
    
    const onCompleteGetStoreList = (data, clientOption) => {
        if(data.arriveInfoList) {
            if(data.arriveInfoList.length > 0) {
                // sort by storeId (text)
                data.arriveInfoList.sort((a,b) => {
                    if(a.storeId < b.storeId) return -1;
                    if(a.storeId > b.storeId) return 1;
                    return 0;
                });
                /* if(!transPlanTsrListParam.storeId) {
                    const newParam = {...transPlanTsrListParam, storeId:data.arriveInfoList[0].storeId};
                    transPlanTsrListParamRepo(newParam);
                } */
            }
            arriveInfoListToSelectStoreRepo({
                when:new Date().getTime()/1000,
                records:data.arriveInfoList
            });
        }
    };

    // 982 Bulk 상품 목록 조회
    const onCompleteGetBulkCompanyProductsList = (data, clientOption) => {
        if(data.bulkCompanyProductsList) {
            bulkCompanyProductsListRepo({when:new Date().getTime()/1000, records:data.bulkCompanyProductsList});
        }
    };
    
    const onCompleteGetVehInfoList = (data, clientOption) => {
        if(data.vehInfoListOfDc) {
            vehInfoListOfDcRepo({
                when:new Date().getTime()/1000,
                records:devideVehiclesByCompany(data.vehInfoListOfDc, vehSorter)
            });
        }
    };
    
    /* ################################################## */
    const onStoreSelected = (id, value) => {
        const newParam = {...listParam, storeId:value};
        setListParam(newParam);
        if(listParam.planDate && IsValid.date(listParam.planDate)) {
            getTransPlanTsrListNow(value, listParam.planDate);
        }
    };

    const onChangePlanDate = (id, value) => {
        const newParam = {...listParam, planDate:value};
        setListParam(newParam);
    };

    const onClickGetList = () => {
        if(listParam.storeId && IsValid.date(listParam.planDate)) {
            getTransPlanTsrListNow(listParam.storeId, listParam.planDate);
        }
    };

    const onClickTab = (hocha) => {
        const idx = tsrBoxList.findIndex(item => item.hocha === hocha);
        if(idx > -1) {
            setSelected({hocha:hocha, item:tsrBoxList[idx].item});
        }
    };

    const onRequestViewDetail = (item) => {
        transPlanTsrItemRepo(item);
        setOpenTsrDetail(true);
    };

    const onCompleteTsrMutation = () => {
        getTransPlanTsrListNow(listParam.storeId, listParam.planDate);
    };

    const loadingAny
    = responseList.loading
    || responseStoreList.loading
    || responseBulkCompanyProductsList.loading;

    return(
        <TopContainer>
            <TopHeader>
                <span>TSR 발행</span>
                {
                    showControls ? null :
                    <div
                        style={{
                            flexGrow:1, fontSize: '0.95rem',
                            overflow:'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis',
                            display:'flex', alignItems:'center', justifyContent:'flex-end',
                            color: AppStyle.PrimaryRGB,
                        }}
                        onClick={() => setShowControls(true)}
                    >
                        {listParam.planDate}, {baseData.arriveInfo && baseData.arriveInfo.storeName}
                        <KeyboardArrowDownIcon style={{marginLeft:'1rem', color: AppStyle.PrimaryRGB}}/>
                    </div>
                }
            </TopHeader>
            <TransitionGroup>
                {
                    showControls &&
                    <Collapse in={showControls}>
                        <ControlLine>
                            <VzmDateField
                                dict={{
                                    id: 'planDate',
                                    label: '출고일자'
                                }}
                                value={listParam.planDate || ''}
                                error={!IsValid.date(listParam.planDate)}
                                onChange={onChangePlanDate}
                            />
                            {
                                responseList.loading ?
                                <CircularProgress size={20} style={{marginLeft: 10}}/>
                                :
                                <Button
                                    variant={AppStyle.mui.contained}
                                    color={AppStyle.mui.primary}
                                    size={AppWord.SMALL}
                                    startIcon={<CloudDownloadIcon />}
                                    style={{marginLeft: 10}}
                                    onClick={onClickGetList}
                                    disabled={loadingAny || !listParam.storeId || !IsValid.date(listParam.planDate)}
                                >
                                    조회
                                </Button>
                            }
                            <div style={{flexGrow:1, textAlign:'right'}}>
                                <IconButton
                                    color={AppStyle.mui.secondary}
                                    size={AppWord.SMALL}
                                    onClick={() => setShowControls(false)}
                                    disabled={tsrBoxList.length === 0}
                                >
                                    <KeyboardArrowUpIcon/>
                                </IconButton>
                            </div>
                        </ControlLine>
                        <ControlLine>
                            <AutoTextField
                                dict={{
                                    id:'storeId',
                                    label:'도착지',
                                    labelKey:'storeName',
                                    getOptionLabel: (opt) => opt.storeName + ' [' + opt.storeId + ']'
                                }}
                                value={listParam.storeId || ''}
                                list={storeList.records}
                                disabled={responseStoreList.loading}
                                style={{minWidth:240, marginLeft: 10}}
                                onChange={onStoreSelected}
                            />
                        </ControlLine>
                    </Collapse>
                }
            </TransitionGroup>
            <ControlLine style={{minHeight: 65}}>
                {
                    tsrBoxList.length === 0 ?
                    <AppBar position="static" color={AppStyle.mui.primary}
                        style={{borderTop: '1px solid #ddd'}}
                    >
                        <Tabs value={0}
                            TabIndicatorProps={{
                            style: {
                                backgroundColor: 'white', // 하이라이트 색상을 흰색으로 변경
                            },
                        }}>
                            <Tab label="호차" disabled={true}
                                style={{color: 'white'}}
                            />
                        </Tabs>
                    </AppBar>
                    :
                    <AppBar position="static" color={AppStyle.mui.primary}
                        style={{borderTop: '1px solid #ddd'}}
                    >
                        <Tabs value={selected.hocha} onChange={(e, v)=>onClickTab(v)}
                            TabIndicatorProps={{
                            style: {
                                backgroundColor: 'yellow', // 하이라이트 색상을 yellow색으로 변경
                            },
                        }}
                        >
                            {
                                tsrBoxList.map((item, idx) => {
                                    return(
                                        <Tab key={idx}
                                            value={item.hocha}
                                            label={`${item.hocha}호`}
                                            onClick={()=>{
                                                setSelected({hocha:item.hocha, item:item.item});
                                                transPlanTsrItemRepo(item.item);
                                            }}
                                            style={{
                                                color: selected.hocha === item.hocha ? 'yellow' : 'white',
                                                fontWeight: selected.hocha === item.hocha ? 'bold' : 'normal',
                                                paddingLeft: 3, paddingRight: 3,
                                                minWidth: 45
                                            }}
                                        />
                                    );
                                })
                            }
                        </Tabs>
                    </AppBar>
                }
            </ControlLine>
            <TopContent>
                {
                    selected.item ?
                    <TransPlanTsrItem
                        item={selected.item}
                        onRequestViewDetail={onRequestViewDetail}
                        onCompleteMutation={onCompleteTsrMutation}
                    />
                    :
                    <NoDataBox
                        title="날짜와 점포를 선택한 후 조회 버튼을 클릭하세요"
                    />
                }
            </TopContent>
            <TransPlanTsrGroup
                open={openTsrDetail}
                onClose={()=>setOpenTsrDetail(false)}
            />
        </TopContainer>
    );
}
